import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

import './TypeTrip.css';

var I18n = require('i18n-react').default;

const propTypes = {
  callbackOnClick: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  active: PropTypes.string
};

const defaultProps = {
  active: 'roundTrip'
};

class TypeTrip extends React.Component {
  constructor(props) {
    super(props);
    this.state = { active: this.props.active };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      active: nextProps.active
    });
  }

  onClick(typeTrip) {
    this.setState({
      active: typeTrip
    });
    this.props.callbackOnClick(typeTrip);
  }

  render() {
    return (
      <div id={`componentTypeTrip-${this.props.id}`}>
        <Row>
          <Col xs={6} sm={6} md={6} lg={1} className="no-padding round-trip column">
            <Button
              id="btnRoundTrip"
              className={`round-trip ${this.state.active === 'roundTrip' ? 'active' : ''} button`}
              onClick={() => {
                this.onClick('roundTrip');
              }}
              bsClass="type-trip"
              ref={c => {
                this.buttonRoundTrip = c;
              }}>
              <span className={'text-type type-trip round-trip'}>
                {I18n.translate('components.typeTrip.roundTrip')}
              </span>
            </Button>
          </Col>
          <Col xs={6} sm={6} md={6} lg={1} className="no-padding one-way column">
            <Button
              id="btnOneWay"
              className={`one-way ${this.state.active === 'oneWay' ? 'active' : ''} button`}
              onClick={() => {
                this.onClick('oneWay');
              }}
              bsClass="type-trip"
              ref={c => (this.buttonOneWay = c)}>
              <span className={'text-type type-trip one-way'}>
                {I18n.translate('components.typeTrip.oneWay')}
              </span>
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

TypeTrip.propTypes = propTypes;
TypeTrip.defaultProps = defaultProps;

export default TypeTrip;



// WEBPACK FOOTER //
// ./src/components/searchBox/typeTrip/TypeTrip.jsx